import React from "react";

// Simplified stylised representation of the National Coat of Arms of Peru:
// left quarter (blue) — Vicuña; right quarter (white) — Cinchona tree;
// bottom (red) — Cornucopia. Followed by laurel & palm wreath.
// Vector art — used only as a small emblematic mark in the header.
export default function Escudo({ className = "", size = 40, title = "Escudo Nacional del Perú" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 72"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {/* Shield outline */}
      <path
        d="M4 6 H60 V38 C60 55 46 66 32 70 C18 66 4 55 4 38 Z"
        fill="#F7F7F5"
        stroke="#0E2A47"
        strokeWidth="2"
      />
      {/* Upper-left quarter — blue with vicuña silhouette */}
      <path d="M4 6 H32 V36 H4 Z" fill="#0E2A47" />
      {/* Vicuña stylised */}
      <g fill="#F1B24A">
        <path d="M11 30 c1-6 6-9 9-9 l1-3 2 2 c1 0 3 1 3 3 l-1 2 c1 1 2 2 2 4 l-2 1 -1 3 -1-2 -3 1 -1 3 -2-1 -1 2 -3-1 -2-5 Z" />
        <circle cx="24" cy="20" r="1" fill="#0E2A47" />
      </g>
      {/* Upper-right quarter — white with cinchona tree */}
      <path d="M32 6 H60 V36 H32 Z" fill="#F7F7F5" />
      <g fill="#0F5F3F">
        <rect x="44" y="24" width="2" height="10" fill="#6B3F1D" />
        <circle cx="45" cy="20" r="6" />
        <circle cx="41" cy="22" r="4" />
        <circle cx="49" cy="22" r="4" />
      </g>
      {/* Bottom half — red with cornucopia */}
      <path
        d="M4 36 H60 V38 C60 55 46 66 32 70 C18 66 4 55 4 38 Z"
        fill="#C8102E"
      />
      <g fill="#F1B24A" stroke="#7A4F17" strokeWidth="0.6">
        <path d="M18 52 c4-6 12-6 16-2 c2 2 4 2 6 0 c-2 4 -6 6 -12 6 c-4 0 -8-1 -10-4 Z" />
        <circle cx="35" cy="49" r="1.2" fill="#F7F7F5" />
        <circle cx="38" cy="50.5" r="1.2" fill="#F7F7F5" />
        <circle cx="41" cy="51" r="1.2" fill="#F7F7F5" />
        <circle cx="33" cy="52" r="1.2" fill="#F7F7F5" />
      </g>
    </svg>
  );
}
